import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-drop-trailers-progress-bar',
  template: `
    <div class="progress">
      <div class="progress-bar" role="progressbar" [ngStyle]="getProgressBarStyle()"></div>
    </div>
  `,
  styles: [`
    .progress {
      height: 20px;
    }
    .progress-bar {
      height: 100%;
    }
  `]
})
export class DropTrailersProgressBarComponent implements ICellRendererAngularComp {
  public params: any;
  public progressUpdates: { status: string; date: string; time: string }[] = [];

  agInit(params: any): void {
    this.params = params;
    this.processProgressUpdates();
  }

  refresh(): boolean {
    return false;
  }

  processProgressUpdates(): void {
    const progressUpdatesString = this.params.value;
    if (progressUpdatesString) {
      const progressUpdatesArray = progressUpdatesString.split(',');
      this.progressUpdates = progressUpdatesArray.map((updateString: string) => {
        const updateParts = updateString.split('|');
        return {
          status: updateParts[0].trim(),
          date: updateParts[1].trim(),
          time: updateParts[2].trim(),
        };
      });
    }
  }

  getProgressBarStyle(): any {
    const completedSteps = this.progressUpdates.length;
    const totalSteps = 8;
    const progressPercentage = (completedSteps / totalSteps) * 100;

    return {
      width: progressPercentage + '%',
      backgroundColor: '#5cb85c'
    };
  }
}